/**
 * @generated SignedSource<<64b777bc4f1e7b1c796698d687216686>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DetailFilterDropdownCategory_category$data = {
  readonly categoryname: string | null | undefined;
  readonly col: string | null | undefined;
  readonly info: {
    readonly " $fragmentSpreads": FragmentRefs<"CategoryInfo_info">;
  } | null | undefined;
  readonly selectbox: {
    readonly " $fragmentSpreads": FragmentRefs<"Selectbox_selectBox">;
  } | null | undefined;
  readonly " $fragmentType": "DetailFilterDropdownCategory_category";
};
export type DetailFilterDropdownCategory_category$key = {
  readonly " $data"?: DetailFilterDropdownCategory_category$data;
  readonly " $fragmentSpreads": FragmentRefs<"DetailFilterDropdownCategory_category">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DetailFilterDropdownCategory_category",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "col",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CategoryInfo",
      "kind": "LinkedField",
      "name": "info",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CategoryInfo_info"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SelectBox",
      "kind": "LinkedField",
      "name": "selectbox",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Selectbox_selectBox"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DetailFilterDropdownCategory",
  "abstractKey": null
};

(node as any).hash = "87d659652a0c812a2ae64be60ac4bcae";

export default node;
